import type { IBettingPageInfo, IExchangeCustomerInfo } from '@/interface/exchange';
import type { ExchangeResponseOfBettingPageResponse, ExchangeResponseOfCustomerInfoResponse } from '@/interface/pollux';
import { ExchangeStatus } from '@/interface/pollux';

export function formatExchangeCustomerInfo(customerInfo: ExchangeResponseOfCustomerInfoResponse): IExchangeCustomerInfo | null {
    if (customerInfo.status === ExchangeStatus.Error || !customerInfo.data) {
        return null;
    }

    return {
        betCredit: customerInfo.data.betCredit,
        hasBettingBudget: customerInfo.data.hasBettingBudget,
        bettingBudget: customerInfo.data.bettingBudget,
        isSuspended: customerInfo.data.isSuspended,
        exchangeBalance: customerInfo.data.exchangeBalance,
        hasDepositBonus: customerInfo.data.hasDepositBonus,
    };
}

export function formatBettingPageInfo(bettingPageInfo: ExchangeResponseOfBettingPageResponse): IBettingPageInfo | null {
    if (bettingPageInfo.status === ExchangeStatus.Error || !bettingPageInfo.data) {
        return null;
    }
    return {
        url: bettingPageInfo.data.iframeUrl ?? '',
        bettingBudget: bettingPageInfo.data.bettingBudget,
        betCredit: bettingPageInfo.data.betCredit,
        hasBettingBudget: bettingPageInfo.data.hasBettingBudget,
        isSuspended: bettingPageInfo.data.isSuspended,
        exchangeBalance: bettingPageInfo.data.exchangeBalance,
        hasDepositBonus: bettingPageInfo.data.hasDepositBonus,
    };
}
